var audio_default = {
  "fontElementMap": "D4Qhm",
  "container": "SxBjL",
  "coverImageContainer": "c-RDe",
  "customPlayer": "PLsZp",
  "slim": "qA2d5",
  "playPauseButton": "Huo2E",
  "coverImage": "_6X5BJ",
  "trackDetailsContainer": "_-4R92",
  "controlsContainer": "wkyvA",
  "controlsGroup": "OqSpE",
  "sliderContainer": "BF4Xj",
  "audioDuration": "_2hqR3",
  "isLoading": "W1I5V",
  "audioDetails": "OBNGd",
  "authorName": "_3X-Rj",
  "title": "-sNz7",
  "dropdownMenuWrapper": "ebpMr",
  "dropdownSelectedButton": "hczOB",
  "dropdownContent": "ELq71",
  "dropdownContentWithIcon": "Sa-lt",
  "audioLoader": "Mew-2"
};
export {
  audio_default as default
};
//# sourceMappingURL=audio-scss.js.map
